import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { ENUMPOASteps, usePOAStepsStore } from "../ui/poaStepsDataStore";
import { useUpdateCustomerData } from "../ui/customerDataStore";

export const usePageViewTracking = () => {
  const [cookies] = useCookies();
  const { currentStep } = usePOAStepsStore();
  const {
    customerData: { credentials },
  } = useUpdateCustomerData();
  const fidQuery = credentials?.identityId
    ? `&fid=${credentials?.identityId}`
    : "";

  const params = window.location.search
    ? `&${new URLSearchParams(window.location.search).toString()}`
    : "";

  useEffect(() => {
    let isMounted = true;
    const capturePageview = async () => {
      if (!isMounted) return;
      try {
        await fetch(`${import.meta.env.VITE_API_URL}/tracking/pageview`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            created_at: new Date().toISOString(),
            uid: cookies.uid,
            user_agent: navigator.userAgent,
            origin: window.location.origin,
            path: location.pathname,
            query: `?step=${ENUMPOASteps[currentStep]}${fidQuery}${params}`,
          }),
        });

        if (!isMounted) return;
      } catch (error) {
        if (isMounted) {
          console.error(error);
        }
      }
    };

    if (cookies.uid) {
      capturePageview();
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep, cookies.uid]);

  return null; // This component doesn't render anything
};
